import './AppBar.css';

class VerticalMenu {
    static get toolbox() {
        return {
            title: 'Menu Vertical',
            icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4ZM15 5C15 6.65685 13.6569 8 12 8C10.3431 8 9 6.65685 9 5C9 3.34315 10.3431 2 12 2C13.6569 2 15 3.34315 15 5ZM12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12ZM11 19C11 18.4477 11.4477 18 12 18C12.5523 18 13 18.4477 13 19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19ZM12 22C13.6569 22 15 20.6569 15 19C15 17.3431 13.6569 16 12 16C10.3431 16 9 17.3431 9 19C9 20.6569 10.3431 22 12 22Z" fill="#000000"></path> </g></svg>'
        };
    }

    constructor({ data, block, api, config }) {
        console.log('>>>constructor<<<<', data)
        this.api = api;
        this.blockAPI = block;
        this.config = config || {};

        this.config.svgEdit  = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M21.2799 6.40005L11.7399 15.94C10.7899 16.89 7.96987 17.33 7.33987 16.7C6.70987 16.07 7.13987 13.25 8.08987 12.3L17.6399 2.75002C17.8754 2.49308 18.1605 2.28654 18.4781 2.14284C18.7956 1.99914 19.139 1.92124 19.4875 1.9139C19.8359 1.90657 20.1823 1.96991 20.5056 2.10012C20.8289 2.23033 21.1225 2.42473 21.3686 2.67153C21.6147 2.91833 21.8083 3.21243 21.9376 3.53609C22.0669 3.85976 22.1294 4.20626 22.1211 4.55471C22.1128 4.90316 22.0339 5.24635 21.8894 5.5635C21.7448 5.88065 21.5375 6.16524 21.2799 6.40005V6.40005Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M11 4H6C4.93913 4 3.92178 4.42142 3.17163 5.17157C2.42149 5.92172 2 6.93913 2 8V18C2 19.0609 2.42149 20.0783 3.17163 20.8284C3.92178 21.5786 4.93913 22 6 22H17C19.21 22 20 20.2 20 18V13" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>';
        this.config.svgAdd   = '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title></title> <g id="Complete"> <g data-name="add" id="add-2"> <g> <line fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" x1="12" x2="12" y1="19" y2="5"></line> <line fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" x1="5" x2="19" y1="12" y2="12"></line> </g> </g> </g> </g></svg>';
        this.config.svgRemove= '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="Edit / Remove_Minus"> <path id="Vector" d="M6 12H18" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g> </g></svg>';
        this.config.svgUp    = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M12 7C12.2652 7 12.5196 7.10536 12.7071 7.29289L19.7071 14.2929C20.0976 14.6834 20.0976 15.3166 19.7071 15.7071C19.3166 16.0976 18.6834 16.0976 18.2929 15.7071L12 9.41421L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L11.2929 7.29289C11.4804 7.10536 11.7348 7 12 7Z" fill="#000000"></path> </g></svg>';
        this.config.svgDown  = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M4.29289 8.29289C4.68342 7.90237 5.31658 7.90237 5.70711 8.29289L12 14.5858L18.2929 8.29289C18.6834 7.90237 19.3166 7.90237 19.7071 8.29289C20.0976 8.68342 20.0976 9.31658 19.7071 9.70711L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L4.29289 9.70711C3.90237 9.31658 3.90237 8.68342 4.29289 8.29289Z" fill="#000000"></path> </g></svg>';
        this.config.svgDivider='<svg width="24" height="24" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M2 7.5C2 7.22386 2.22386 7 2.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H2.5C2.22386 8 2 7.77614 2 7.5Z" fill="#000000"></path> </g></svg>';
        this.config.svgcancel   ='<svg width="24" height="24" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <defs> <style>.cls-1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}</style> </defs> <title></title> <g id="cross"> <line class="cls-1" x1="7" x2="25" y1="7" y2="25"></line> <line class="cls-1" x1="7" x2="25" y1="25" y2="7"></line> </g> </g></svg><svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <defs> <style>.cls-1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}</style> </defs> <title></title> <g id="cross"> <line class="cls-1" x1="7" x2="25" y1="7" y2="25"></line> <line class="cls-1" x1="7" x2="25" y1="25" y2="7"></line> </g> </g></svg>'
        this.config.svgSave     ='<svg width="24" height="24" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <defs> <style>.cls-1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}</style> </defs> <title></title> <g id="checkmark"> <line class="cls-1" x1="3" x2="12" y1="16" y2="25"></line> <line class="cls-1" x1="12" x2="29" y1="25" y2="7"></line> </g> </g></svg>'

        this.data = Array.isArray(data)?data:[];
        console.log( typeof this.data);

        this.addButton = null;
        this.cancelEditButton = null;

        this.wrapper = undefined;
    }

    static get sanitize() {
        return {
            icone: true,
            nome: true,
            href: true,
            api: true,
            rule: true
        }
    }

    render() {
         
        this.wrapper = document.createElement('div');
        this.wrapper.classList.add('main-div');

        const mainDiv = document.createElement('div');
        mainDiv.classList.add('app-bar');

        let button = document.createElement('button');        
        button.classList.add(this.api.styles.settingsButton);
        //button.id="btn-icon-add";
        button.innerHTML = this.config.svgEdit;

        let l = document.createElement("label");
        l.innerHTML = 'Icone';
        button.appendChild(l);

        button.addEventListener('click', (e) => {
            let result = prompt("Indique o icone no padrão svg. \nConfirme se existe os parametros de tamanho no svg: width=\"24\" height=\"24\"",
                            this.config.svgEdit);
            
            const btn = e.target; //const btn = document.getElementById("btn-icon-add");
            btn.innerHTML = result;
            const hd = document.querySelector('#VMenu-btnSvg');
            hd.value = result;

            let l = document.createElement("label");
            l.innerHTML = 'Icone';
            btn.appendChild(l);
        });
        mainDiv.appendChild(button);

        let divider = document.createElement('div');
        divider.classList.add('verticalDivider');
        mainDiv.appendChild(divider);

        let hide = document.createElement('input');
        hide.type = 'hidden'
        hide.id = "VMenu-btnSvg";
        hide.value = this.config.svgEdit;
        mainDiv.appendChild(hide);

        //nome do item

        let inputT = document.createElement('input');
        inputT.classList.add('inputTxtSmall');
        inputT.id = "VMenu-nome";
        
        l = document.createElement("label");
        
        l.for = 'VMenu-nome';
        l.innerHTML = 'Nome: ';
        mainDiv.appendChild(l);
        mainDiv.appendChild(inputT);

        divider = document.createElement('div');
        divider.classList.add('verticalDivider');
        mainDiv.appendChild(divider);

        //href

        inputT = document.createElement('input');
        inputT.id = "VMenu-href";
        
        l = document.createElement("label");
        
        l.for = 'VMenu-href';
        l.innerHTML = 'href: ';
        mainDiv.appendChild(l);
        mainDiv.appendChild(inputT);

        divider = document.createElement('div');
        divider.classList.add('verticalDivider');
        mainDiv.appendChild(divider);

        // API

        inputT = document.createElement('input');
        inputT.classList.add('inputTxtSmall');
        inputT.classList.add('inputTxtNormal');
        inputT.id = "VMenu-api";

        l = document.createElement("label");

        l.for = 'VMenu-api';
        l.innerHTML = 'ou API: ';
        mainDiv.appendChild(l);
        mainDiv.appendChild(inputT);

        divider = document.createElement('div');
        divider.classList.add('verticalDivider');
        mainDiv.appendChild(divider);

        // rule

        inputT = document.createElement('input');
        inputT.classList.add('inputTxtSmall');
        inputT.id = "VMenu-rule";

        l = document.createElement("label");
        
        l.for = 'VMenu-rule';
        l.innerHTML = 'Regra: ';
        mainDiv.appendChild(l);
        mainDiv.appendChild(inputT);

        const buttonContainer = document.createElement('div');
        buttonContainer.classList.add('button-container');
        mainDiv.appendChild(buttonContainer);

        // add btn

        this.addButton = document.createElement('button');
        this.addButton.classList.add(this.api.styles.settingsButton);
        this.addButton.innerHTML = this.config.svgAdd;
        this.addButton.addEventListener('click', (e) => {
            if( !this.data) this.data = [];

            const svg =  document.querySelector('#VMenu-btnSvg').value;
            const nome = document.querySelector('#VMenu-nome').value;
            const href = document.querySelector('#VMenu-href').value;
            const api =  document.querySelector('#VMenu-api').value;
            const rule = document.querySelector('#VMenu-rule').value;
            // const login = blockContent.querySelector('#appBar-loginLogout').checked;
            // const profile = blockContent.querySelector('#appBar-profile').checked;

            const item = {
                icone: svg,
                nome: nome,
                href: href,
                api: api,
                rule: rule?rule:''
            }
            if (this.editingIndex !== undefined && this.editingIndex !== null) {
                console.log("Edição: ", item, "\nindex:", this.editingIndex)
                // Modo edição - substitui o item existente
                this.data[this.editingIndex] = item;
                this.editingIndex = null;
                this.addButton.innerHTML = this.config.svgAdd;
                this.cancelEditButton.style.display = 'none';
                // this._switchToAddMode(); // Volta para o modo de adição
            } else {
                console.log("Adição: ", item, "\nindex:", this.editingIndex)
                // Modo adição - adiciona novo item
                this.data.push(item);
            }

            document.querySelector('#VMenu-btnSvg').value = this.config.svgEdit;        
            document.querySelector('#VMenu-nome').value   = '';
            document.querySelector('#VMenu-href').value   = '';
            document.querySelector('#VMenu-api').value    = '';
            document.querySelector('#VMenu-rule').value   = '';
            
            // this.config.setData({
            //     tipo: 'VerticalMenu',
            //     data: this.data
            // }); 

            this.changeSomeDataProperty();
            this._drawData(null, this.data);
        });
        buttonContainer.appendChild(this.addButton);
        // mainDiv.appendChild(button);

        // Botão de Cancelar Edição (oculto por padrão)
        this.cancelEditButton = document.createElement('button');
        this.cancelEditButton.classList.add(this.api.styles.settingsButton);
        this.cancelEditButton.innerHTML = this.config.svgcancel; // Ou use um SVG de cancelar
        this.cancelEditButton.style.display = 'none';
        this.cancelEditButton.addEventListener('click', (e) => {
            this.editingIndex = null;
            document.querySelector('#VMenu-btnSvg').value = this.config.svgEdit;
            document.querySelector('#VMenu-nome').value = '';
            document.querySelector('#VMenu-href').value = '';
            document.querySelector('#VMenu-api').value = '';
            document.querySelector('#VMenu-rule').value = '';
            this.addButton.innerHTML = this.config.svgAdd;
            this.cancelEditButton.style.display = 'none';
        });
        buttonContainer.appendChild(this.cancelEditButton);

        button = document.createElement('button');
        button.classList.add(this.api.styles.settingsButton);
        button.innerHTML = this.config.svgDivider;
        mainDiv.appendChild(button);
        button.addEventListener('click', (e) => {
            if( !this.data) this.data = [];

            const item = { nome: 'Divider' };
            this.data.push(item);      
            document.querySelector('#VMenu-nome').value   = '';

            this.changeSomeDataProperty();
            this._drawData(null, this.data);
        });
        mainDiv.appendChild(document.createElement('br'));

        const table = document.createElement('table');
        table.id = 'VMenu-table'
        const row = document.createElement('tr');
        const col = ["Icone", "Nome", "href", "API", "Regra", "Ação"];
        for (const key in col) {
            const cell = document.createElement('td');
            cell.textContent = col[key]; // Set cell content
            if( col[key] === 'Nome'){
                cell.style="width: 120px"
            }else if( col[key] === 'Icone'){
                cell.style="width: 32px"
            }else if( col[key] === 'Regra'){
                cell.style="width: 80px"
            }else if( col[key] === 'Ação'){
                cell.style="width: 160px"
            }
            row.appendChild(cell);
        }
        table.appendChild(row);

        const dv = document.createElement('div');
        dv.classList.add('table');
        dv.appendChild(table);        

        this.wrapper.appendChild(mainDiv);
        this.wrapper.appendChild(dv);
        this._drawData(table, this.data);
        return this.wrapper;
    }

    _drawData(table, row) {
        console.log('>>>>_drawData<<<<', this.data );
        
        if( this.data && this.data.length > 0 ){
            if( !table){
              table = document.getElementById('VMenu-table');
            }
            const headerRow = table.querySelector('tr:first-child');
            while (table.lastChild && table.lastChild !== headerRow) {
                table.removeChild(table.lastChild);
            }
            for(let x in row){
                const tr = document.createElement('tr');
                tr.dataset.index = x; 
                const item = row[x];
                
                let cell = document.createElement('td');
                if( item.nome === 'Divider'){
                    cell.textContent = item.nome;
                    cell.colspan = "5";
                    cell.setAttribute('colspan', '5');

                    tr.appendChild(cell); 
                    

                    cell = document.createElement('td');
                    this._addBtnCell(cell);
                    tr.appendChild(cell); 

                    table.appendChild(tr);
                    continue;
                }
                const d = document.createElement('div');
                d.classList.add(this.api.styles.settingsButton);
                d.innerHTML = item.icone
                cell.appendChild(d);
                tr.appendChild(cell);

                cell = document.createElement('td');
                cell.textContent = item.nome; // Set cell content
                tr.appendChild(cell);

                cell = document.createElement('td');
                cell.textContent = item.href; // Set cell content
                tr.appendChild(cell);

                cell = document.createElement('td');
                cell.textContent = item.api; // Set cell content
                tr.appendChild(cell);

                cell = document.createElement('td');
                cell.textContent = item.rule; // Set cell content
                tr.appendChild(cell);

                cell = document.createElement('td');
                
                this._addBtnCell(cell);
                tr.appendChild(cell);

                table.appendChild(tr);
            }
        }
    }

    _createTableHeader(table) {
        const row = document.createElement('tr');
        const col = ["Icone", "Nome", "href", "API", "Regra", "Ação"];
    
        for (const key in col) {
            const cell = document.createElement('td');
            cell.textContent = col[key];
    
            if (col[key] === 'Nome') {
                cell.style = "width: 120px";
            } else if (col[key] === 'Icone') {
                cell.style = "width: 32px";
            } else if (col[key] === 'Regra') {
                cell.style = "width: 80px";
            } else if (col[key] === 'Ação') {
                cell.style = "width: 160px";
            }
    
            row.appendChild(cell);
        }
    
        table.appendChild(row);
    }

    _redrawTable() {
        const table = document.getElementById('VMenu-table');
        if (table) {
            table.innerHTML = ''; // limpa tudo
            this._createTableHeader(table);
            this._drawData(table, this.data); // redesenha
        }
    }

    _addBtnCell(cell){
        let button = document.createElement('button');        
        button.classList.add(this.api.styles.settingsButton);
        button.innerHTML = this.config.svgRemove;
        button.addEventListener('click', (e) => {
            console.log("Clicou no botão Remover AaaaaaaaaA", this.data, cell);

            const tr = e.target.closest('tr');
            if (!tr) return;
            console.log("tr:", tr)
            const index = parseInt(tr.dataset.index);
            console.log("index:", index)
            if (!isNaN(index)) {
                this.data.splice(index, 1); // Remove do array
                console.log("Item removido de this.data:", index);
            }
            tr.remove(); // Remove da tabela
        });
        cell.appendChild( button);

        button = document.createElement('button');        
        button.classList.add(this.api.styles.settingsButton);
        button.innerHTML = this.config.svgUp;
        button.addEventListener('click', (e) => {
            const tr = e.target.closest('tr');
            const index = parseInt(tr.dataset.index);
            if (index > 0) {
                // troca no array
                [this.data[index - 1], this.data[index]] = [this.data[index], this.data[index - 1]];
                this._redrawTable();
            }
        });
        cell.appendChild( button);

        button = document.createElement('button');        
        button.classList.add(this.api.styles.settingsButton);
        button.innerHTML = this.config.svgDown;
        button.addEventListener('click', (e) => {
            const tr = e.target.closest('tr');
            const index = parseInt(tr.dataset.index);
            if (index < this.data.length - 1) {
                // troca no array
                [this.data[index + 1], this.data[index]] = [this.data[index], this.data[index + 1]];
                this._redrawTable();
            }
        });
        cell.appendChild( button);

        // Botão Editar
        button = document.createElement('button');        
        button.classList.add(this.api.styles.settingsButton);
        button.innerHTML = this.config.svgEdit;
        button.addEventListener('click', (e) => {
            const tr = e.target.closest('tr');
            const index = parseInt(tr.dataset.index);
            if (isNaN(index)) return;
        
            const item = this.data[index];
            // 1. Preenche os campos superiores com os dados da linha
            document.querySelector('#VMenu-btnSvg').value = item?.icone || this.config.svgEdit;
            document.querySelector('#VMenu-nome').value = item.nome || '';
            document.querySelector('#VMenu-href').value = item.href || '';
            document.querySelector('#VMenu-api').value = item.api || '';
            document.querySelector('#VMenu-rule').value = item.rule || '';

            const iconButton = document.querySelector('.app-bar button:first-child');
            if (iconButton) {
              iconButton.innerHTML = item.icone || this.config.svgEdit;
              
              // Adiciona o label "Ícone" novamente (se necessário)
              const existingLabel = iconButton.querySelector('label');
              if (!existingLabel) {
                const l = document.createElement("label");
                l.innerHTML = 'Icone';
                iconButton.appendChild(l);
              }
            }
            
            // 2. Armazena o índice do item que está sendo editado
            this.editingIndex = index;
            this.addButton.innerHTML = this.config.svgSave;
            this.cancelEditButton.style.display = 'none';
            
            // 3. Rola a página para o topo
            window.scrollTo({ top: 0, behavior: 'smooth' });
            

            });
        cell.appendChild( button);
    }

    changeSomeDataProperty() {
        this.blockAPI.dispatchChange();
    }

    save(blockContent) {
        // if( !this.data) this.data = [];

        // const svg = blockContent.querySelector('#VMenu-btnSvg').innerHTML;
        // const nome = blockContent.querySelector('#VMenu-nome').value;
        // const href = blockContent.querySelector('#VMenu-href').value;
        // const api = blockContent.querySelector('#VMenu-api').value;
        // const rule = blockContent.querySelector('#VMenu-rule').value;
        // // const login = blockContent.querySelector('#appBar-loginLogout').checked;
        // // const profile = blockContent.querySelector('#appBar-profile').checked;

        // this.data.push({
        //     svg: svg,
        //     nome: nome,
        //     href: href,
        //     api: api,
        //     rule: rule
        // });
        
        return this.data;
    }

    validate(savedData) {
        // if (!savedData.url.trim()) {
        //     return false;
        // }
        return true;
    }

    renderSettings() {
        const wrapper = document.createElement('div');
        let button = document.createElement('button');
        button.classList.add(this.api.styles.settingsButton);
        // button.classList.add(this.api.styles.block);
        button.innerHTML = '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M21.2799 6.40005L11.7399 15.94C10.7899 16.89 7.96987 17.33 7.33987 16.7C6.70987 16.07 7.13987 13.25 8.08987 12.3L17.6399 2.75002C17.8754 2.49308 18.1605 2.28654 18.4781 2.14284C18.7956 1.99914 19.139 1.92124 19.4875 1.9139C19.8359 1.90657 20.1823 1.96991 20.5056 2.10012C20.8289 2.23033 21.1225 2.42473 21.3686 2.67153C21.6147 2.91833 21.8083 3.21243 21.9376 3.53609C22.0669 3.85976 22.1294 4.20626 22.1211 4.55471C22.1128 4.90316 22.0339 5.24635 21.8894 5.5635C21.7448 5.88065 21.5375 6.16524 21.2799 6.40005V6.40005Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M11 4H6C4.93913 4 3.92178 4.42142 3.17163 5.17157C2.42149 5.92172 2 6.93913 2 8V18C2 19.0609 2.42149 20.0783 3.17163 20.8284C3.92178 21.5786 4.93913 22 6 22H17C19.21 22 20 20.2 20 18V13" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>';

        let l = document.createElement("label");
        l.innerHTML = 'Editar';
        button.appendChild(l);

        wrapper.appendChild(button);

        button.addEventListener('click', () => {
            this.config.setOpen(true);
            this.config.setData({
                tipo: 'AppBar',
                data: this.data
            });
        });

        return wrapper;
    }
}
export default VerticalMenu